<template>
<div>
<div class="relative inline-block w-10 align-middle select-none transition duration-200 ease-in">
    <input     
    v-bind="$attrs"
    v-on="$listeners"
    :checked="!!value"
    @change="$emit('update', $event.target.checked)"
    :disabled="disabled"
    type="checkbox" name="toggle" id="toggle" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border appearance-none cursor-pointer focus:outline-none "/>    
    <label for="toggle" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
</div>
</div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: ["value", "disabled"],
  model: {
    prop: "value",
    event: "update",
  },
};
</script>

<style scoped>
.toggle-checkbox:checked {
  @apply: right-0 border-green-400;
  right: 0;
  border-color: #68D391;
}
.toggle-checkbox:checked + .toggle-label {
  @apply: bg-green-400;
  background-color: #68D391;
}
</style>
